import { render, staticRenderFns } from "./ShieldCheckIcon.vue?vue&type=template&id=68816432&"
import script from "./ShieldCheckIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShieldCheckIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports